import { createReducer, on } from '@ngrx/store';
import {
  handleRequest,
  handleSuccess,
  handleFailure,
  handleClear,
} from '@shared/ngrx-factory/factory.reducer';
import {
  sarimaPredictActions,
  predictAllActions,
  sarimaRetrainActions,
  sarimaRetrainAllActions,
  sarimaIngestImportsActions,
  sarimaHealthActions,
  sarimaModelsActions,
  sarimaModelRunsActions,
  sarimaModelRunByIdActions,
  sarimaLatestModelRunActions,
  sarimaImportsActions,
  sarimaImportSummaryActions,
  sarimaLatestChartDataActions,
  sarimaForecastByIdActions,
  sarimaChartDataByIdActions,
  sarimaTestPredictionsActions,
  sarimaUploadImportsActions,
} from './smart-forecasting.actions';
import { initialSmartForecastingState } from './smart-forecasting.state';

export const smartForecastingReducer = createReducer(
  initialSmartForecastingState,
  
  // Sarima Predict
  on(sarimaPredictActions.request, (state) => handleRequest(state, 'sarimaPredict')),
  on(sarimaPredictActions.success, (state, { response }) => handleSuccess(state, 'sarimaPredict', response)),
  on(sarimaPredictActions.failure, (state, { error }) => handleFailure(state, 'sarimaPredict', error)),
  on(sarimaPredictActions.clearState, (state) => handleClear(state, 'sarimaPredict')),

  // Predict All
  on(predictAllActions.request, (state) => handleRequest(state, 'predictAll')),
  on(predictAllActions.success, (state, { response }) => handleSuccess(state, 'predictAll', response)),
  on(predictAllActions.failure, (state, { error }) => handleFailure(state, 'predictAll', error)),
  on(predictAllActions.clearState, (state) => handleClear(state, 'predictAll')),

  // Sarima Retrain
  on(sarimaRetrainActions.request, (state) => handleRequest(state, 'sarimaRetrain')),
  on(sarimaRetrainActions.success, (state, { response }) => handleSuccess(state, 'sarimaRetrain', response)),
  on(sarimaRetrainActions.failure, (state, { error }) => handleFailure(state, 'sarimaRetrain', error)),
  on(sarimaRetrainActions.clearState, (state) => handleClear(state, 'sarimaRetrain')),

  // Sarima Retrain All
  on(sarimaRetrainAllActions.request, (state) => handleRequest(state, 'sarimaRetrainAll')),
  on(sarimaRetrainAllActions.success, (state, { response }) => handleSuccess(state, 'sarimaRetrainAll', response)),
  on(sarimaRetrainAllActions.failure, (state, { error }) => handleFailure(state, 'sarimaRetrainAll', error)),
  on(sarimaRetrainAllActions.clearState, (state) => handleClear(state, 'sarimaRetrainAll')),

  // Sarima Ingest Imports
  on(sarimaIngestImportsActions.request, (state) => handleRequest(state, 'sarimaIngestImports')),
  on(sarimaIngestImportsActions.success, (state, { response }) => handleSuccess(state, 'sarimaIngestImports', response)),
  on(sarimaIngestImportsActions.failure, (state, { error }) => handleFailure(state, 'sarimaIngestImports', error)),
  on(sarimaIngestImportsActions.clearState, (state) => handleClear(state, 'sarimaIngestImports')),

  // Sarima Health
  on(sarimaHealthActions.request, (state) => handleRequest(state, 'sarimaHealth')),
  on(sarimaHealthActions.success, (state, { response }) => handleSuccess(state, 'sarimaHealth', response)),
  on(sarimaHealthActions.failure, (state, { error }) => handleFailure(state, 'sarimaHealth', error)),
  on(sarimaHealthActions.clearState, (state) => handleClear(state, 'sarimaHealth')),

  // Sarima Models
  on(sarimaModelsActions.request, (state) => handleRequest(state, 'sarimaModels')),
  on(sarimaModelsActions.success, (state, { response }) => handleSuccess(state, 'sarimaModels', response)),
  on(sarimaModelsActions.failure, (state, { error }) => handleFailure(state, 'sarimaModels', error)),
  on(sarimaModelsActions.clearState, (state) => handleClear(state, 'sarimaModels')),

  // Sarima Model Runs
  on(sarimaModelRunsActions.request, (state) => handleRequest(state, 'sarimaModelRuns')),
  on(sarimaModelRunsActions.success, (state, { response }) => handleSuccess(state, 'sarimaModelRuns', response)),
  on(sarimaModelRunsActions.failure, (state, { error }) => handleFailure(state, 'sarimaModelRuns', error)),
  on(sarimaModelRunsActions.clearState, (state) => handleClear(state, 'sarimaModelRuns')),

  // Sarima Model Run By Id
  on(sarimaModelRunByIdActions.request, (state) => handleRequest(state, 'sarimaModelRunById')),
  on(sarimaModelRunByIdActions.success, (state, { response }) => handleSuccess(state, 'sarimaModelRunById', response)),
  on(sarimaModelRunByIdActions.failure, (state, { error }) => handleFailure(state, 'sarimaModelRunById', error)),
  on(sarimaModelRunByIdActions.clearState, (state) => handleClear(state, 'sarimaModelRunById')),

  // Sarima Latest Model Run
  on(sarimaLatestModelRunActions.request, (state) => handleRequest(state, 'sarimaLatestModelRun')),
  on(sarimaLatestModelRunActions.success, (state, { response }) => handleSuccess(state, 'sarimaLatestModelRun', response)),
  on(sarimaLatestModelRunActions.failure, (state, { error }) => handleFailure(state, 'sarimaLatestModelRun', error)),
  on(sarimaLatestModelRunActions.clearState, (state) => handleClear(state, 'sarimaLatestModelRun')),

  // Sarima Imports
  on(sarimaImportsActions.request, (state) => handleRequest(state, 'sarimaImports')),
  on(sarimaImportsActions.success, (state, { response }) => handleSuccess(state, 'sarimaImports', response)),
  on(sarimaImportsActions.failure, (state, { error }) => handleFailure(state, 'sarimaImports', error)),
  on(sarimaImportsActions.clearState, (state) => handleClear(state, 'sarimaImports')),

  // Sarima Import Summary
  on(sarimaImportSummaryActions.request, (state) => handleRequest(state, 'sarimaImportSummary')),
  on(sarimaImportSummaryActions.success, (state, { response }) => handleSuccess(state, 'sarimaImportSummary', response)),
  on(sarimaImportSummaryActions.failure, (state, { error }) => handleFailure(state, 'sarimaImportSummary', error)),
  on(sarimaImportSummaryActions.clearState, (state) => handleClear(state, 'sarimaImportSummary')),

  // Sarima Latest Chart Data
  on(sarimaLatestChartDataActions.request, (state) => {
    const nextState = handleRequest(state, 'sarimaLatestChartData');
    return {
      ...nextState,
      sarimaLatestChartData: {
        ...nextState.sarimaLatestChartData,
        response: null
      }
    };
  }),
  on(sarimaLatestChartDataActions.success, (state, { response }) => handleSuccess(state, 'sarimaLatestChartData', response)),
  on(sarimaLatestChartDataActions.failure, (state, { error }) => {
    const nextState = handleFailure(state, 'sarimaLatestChartData', error);
    return {
      ...nextState,
      sarimaLatestChartData: {
        ...nextState.sarimaLatestChartData,
        response: null
      }
    };
  }),
  on(sarimaLatestChartDataActions.clearState, (state) => handleClear(state, 'sarimaLatestChartData')),

  // Sarima Forecast By Id
  on(sarimaForecastByIdActions.request, (state) => handleRequest(state, 'sarimaForecastById')),
  on(sarimaForecastByIdActions.success, (state, { response }) => handleSuccess(state, 'sarimaForecastById', response)),
  on(sarimaForecastByIdActions.failure, (state, { error }) => handleFailure(state, 'sarimaForecastById', error)),
  on(sarimaForecastByIdActions.clearState, (state) => handleClear(state, 'sarimaForecastById')),

  // Sarima Chart Data By Id
  on(sarimaChartDataByIdActions.request, (state) => handleRequest(state, 'sarimaChartDataById')),
  on(sarimaChartDataByIdActions.success, (state, { response }) => handleSuccess(state, 'sarimaChartDataById', response)),
  on(sarimaChartDataByIdActions.failure, (state, { error }) => handleFailure(state, 'sarimaChartDataById', error)),
  on(sarimaChartDataByIdActions.clearState, (state) => handleClear(state, 'sarimaChartDataById')),

  // Sarima Test Predictions
  on(sarimaTestPredictionsActions.request, (state) => handleRequest(state, 'sarimaTestPredictions')),
  on(sarimaTestPredictionsActions.success, (state, { response }) => handleSuccess(state, 'sarimaTestPredictions', response)),
  on(sarimaTestPredictionsActions.failure, (state, { error }) => handleFailure(state, 'sarimaTestPredictions', error)),
  on(sarimaTestPredictionsActions.clearState, (state) => handleClear(state, 'sarimaTestPredictions')),

  // Sarima Upload Imports
  on(sarimaUploadImportsActions.request, (state) => handleRequest(state, 'sarimaUploadImports')),
  on(sarimaUploadImportsActions.success, (state, { response }) => handleSuccess(state, 'sarimaUploadImports', response)),
  on(sarimaUploadImportsActions.failure, (state, { error }) => handleFailure(state, 'sarimaUploadImports', error)),
  on(sarimaUploadImportsActions.clearState, (state) => handleClear(state, 'sarimaUploadImports'))
);
